import { Link } from "@/lib/router-compat";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const steps = [
  {
    number: "01",
    title: "Free Inspection",
    description: "We start with a thorough inspection of your roof, siding, or exterior. We document everything with photos and provide a detailed assessment — no obligation, no pressure.",
  },
  {
    number: "02",
    title: "Custom Proposal",
    description: "Based on our findings, we build a tailored proposal with material options, transparent pricing, and a clear timeline. We'll walk you through every detail so you can make a confident decision.",
  },
  {
    number: "03",
    title: "Expert Installation",
    description: "Our experienced crews execute the project with precision, using premium materials and manufacturer-recommended techniques. We leave your property clean and your investment protected.",
  },
];

export const ProcessSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            THE KODIAK PROCESS
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed">
            We make exterior projects simple and stress-free. From first call to final walkthrough, here's what to expect.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {steps.map((step) => (
            <div key={step.title} className="text-center">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-secondary/10 flex items-center justify-center">
                <span className="text-3xl font-heading font-bold text-secondary">{step.number}</span>
              </div>
              <h3 className="text-2xl font-heading font-bold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="flex justify-center">
          <Link to="/contact">
            <Button className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold font-subheading px-8">
              Get a Free Estimate <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
